import React from 'react';
import { Box, Typography } from '@mui/material';

type SettingsCardProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
};

// White surface matching the design: 12px radius, soft shadow, Lexend title.
function SettingsCard({ title, subtitle, children }: SettingsCardProps) {
  return (
    <Box
      component="section"
      sx={{
        bgcolor: '#fff',
        borderRadius: '12px',
        boxShadow: '0px 0px 8px rgba(0,0,0,0.08)',
        p: { xs: '22px 20px', md: '28px' },
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: { xs: 19, md: 20 }, color: 'rgba(0,0,0,0.87)' }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', mt: 0.75, lineHeight: 1.5 }}
        >
          {subtitle}
        </Typography>
      )}
      <Box sx={{ mt: { xs: '22px', md: 3 } }}>{children}</Box>
    </Box>
  );
}

export default SettingsCard;
